import { Input } from '../Form/Input';
import { AddressDropdown } from './AddressDropdown';

export const Address = ({
  containerRef,
  isMobile,
  isAddressInvalid,
  address,
  addressError,
  onAddressChange,
  onSetStep,
  onOpenDropdown,
  setDisplayedAddress = null,
  addresses,
  disabled,
  onSelectAddress,
  loading,
  onResetAddress,
  onAddressBlur,
  opened,
  className = '',
}) => {
  return (
    <div className={`w-full ${className}`} ref={containerRef}>
      <Input
        icon="icon-home-1"
        label="form.input.address.label"
        placeholder="form.input.address.placeholder"
        withoutBG
        error={!isMobile && isAddressInvalid}
        errorText={!isMobile && address ? addressError : ''}
        onChange={onAddressChange}
        value={address}
        onClick={(e) => {
          if (isMobile) {
            return onSetStep('address');
          }
          onOpenDropdown(e);
        }}
        onBlur={onAddressBlur}
        onReset={(e) => {
          if (isMobile) {
            e.stopPropagation();
          }
          onResetAddress(e);
          if (setDisplayedAddress) setDisplayedAddress('');
        }}
        dataTestid="inquiryAddress"
        disabled={disabled}
        readOnly={isMobile}
        theme="outlined"
        size="md"
      />
      {opened && !isMobile && (
        <div className="relative">
          <AddressDropdown
            className="!absolute top-2 z-10 max-sm:!pr-0 max-sm:!pl-4 max-sm:!py-4 max-sm:!min-h-10"
            items={addresses}
            onSelect={(e) => {
              onSelectAddress(e);
              if (setDisplayedAddress) setDisplayedAddress(e);
            }}
            loading={loading}
            dataTestid="inquiryAddressDropdown"
          />
        </div>
      )}
    </div>
  );
};
